// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseAppAccessControlAreaRoutes = {
  route: '/app-access-control',
}

export const AppAccessControlAreaRoutes = transformRoutes(
  BaseAppAccessControlAreaRoutes,
)
